<div class="container container-about">
    <main id="main-about">
        <img id="profile-pic" src="https://i.imgur.com/pnfFJl1.png?1" alt="Profile picture">

        <mat-card>
            <mat-card-title>
                About me
            </mat-card-title>
            <mat-card-content>Full stack developer. I was in the end of accounting school, working in financial statements audit, when a frind of mine invited me to the Nasa Space Apps hackathon. I loved it so much I decided to work as a software developer, so I quit my job and joined the Generation bootcamp.</mat-card-content>
        </mat-card>

        <mat-card>
            <mat-card-title>
                Hobbies
            </mat-card-title>
            <mat-card-content>I enjoy watching movies, TV series and anime. My favorite anime is Death Note and I love House!</mat-card-content>
        </mat-card>
    </main>
</div>